import React from "react";
import { func } from "prop-types";
import { connect } from "react-redux";
import { showModal } from "ducks/modals.js"; // eslint-disable-line import/no-extraneous-dependencies
import { Row, Col, Button, Table, FormGroup, ControlLabel, FormControl, InputGroup } from "react-bootstrap";
import ContentWrapper from "../../layout/ContentWrapper";
import { table } from "./table";

const VerifyMembership = ({ handleOpenNewBuilderModal }) => (
  <ContentWrapper>
    <div className="content-heading">Membership and Eligibility</div>
    <Row>
      <Col xs={12}>
        <div className="stacked-filter-panel">
          <FormGroup controlId="city" className="city-filter">
            <ControlLabel>Name:</ControlLabel>
            <FormControl componentClass="select" placeholder="All">
              <option value="select">All</option>
              <option value="other">...</option>
            </FormControl>
          </FormGroup>
          <FormGroup controlId="stage" className="stage-filter">
            <ControlLabel>State:</ControlLabel>
            <FormControl componentClass="select" placeholder="All">
              <option value="select">All</option>
              <option value="other">...</option>
            </FormControl>
          </FormGroup>
          <FormGroup className="search-filter">
            <ControlLabel>Search:</ControlLabel>
            <InputGroup>
              <FormControl type="text" />
              <InputGroup.Button>
                <Button>
                  <i className="fa fa-search" aria-hidden="true" />
                </Button>
              </InputGroup.Button>
            </InputGroup>
          </FormGroup>
          <Button bsStyle="primary" onClick={handleOpenNewBuilderModal}>
            <i className="fa fa-check" aria-hidden="true" />&nbsp; Verify
          </Button>
        </div>
      </Col>
    </Row>
    <Row>
      <Col xs={12}>
        <Table striped>
          <thead>
            <tr>
              <th>Event Name</th>
              <th>Address</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Director</th>
              <th>Status</th>
              <th style={{ width: "60px" }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {table &&
              table.map((item, key) => (
                <tr key={key}>
                  <td>
                    <a href="#">{item.name}</a>
                  </td>
                  <td>{item.address}</td>
                  <td>{item.address}</td>
                  <td>{item.address}</td>
                  <td>{item.address}</td>
                  <td>
                    <a href="#">{item.status}</a>
                  </td>
                
              
                  <td>
                    <Button bsStyle="default">
                      <i className="fa fa-angle-right" aria-hidden="true" />
                    </Button>
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </Col>
    </Row>
  </ContentWrapper>
)
VerifyMembership.propTypes = {
  handleOpenNewBuilderModal: func,
}
const mapDispatchToProps = dispatch => ({
  handleOpenNewBuilderModal: () => dispatch(showModal("ADD_NEW_BUILDER")),
})

export default connect(null, mapDispatchToProps)(VerifyMembership);



// WEBPACK FOOTER //
// ./src/components/pages/VerifyMembership/index.js